/** @format */

import { AuthProvider } from "@/hooks/useAuth";
import { Outlet } from "react-router-dom";

/**
 * AuthLayout - Wraps routes with AuthProvider
 * This component is rendered inside the router context,
 * allowing AuthProvider to use router hooks like useNavigate()
 */
export function AuthLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

